import type { User } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { HookedSubmitButton } from '../../components/forms/V3HookedSubmitButton';
import { createModal } from '../../components/generic/Modal';
import { useRequestResetMfaEmailMutation } from '../../graphql/hooks/useRequestResetMfaEmailMutation';
import { useAppContext } from '../../hooks/useAppContext';

interface Props {
  user: User;
}

export const UserResetMfaModal = createModal<Props>((props) => {
  const { user, modal } = props;
  const mutation = useRequestResetMfaEmailMutation();
  const { visible, hide, remove } = modal;
  const { successToast, errorToast } = useAppContext();

  const methods = useForm({});

  const onSubmit = async () => {
    await mutation
      .mutateAsync({ email: user.email })
      .then(() => {
        successToast('Reset MFA email sent successfully');
        hide();
      })
      .catch((error) => {
        errorToast(`Error resetting MFA: ${error.message}`);
      });
  };

  return (
    <ChakraV3.Dialog.Root open={visible} onOpenChange={hide} onExitComplete={remove}>
      <ChakraV3.Dialog.Backdrop />
      <ChakraV3.Dialog.Positioner>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <ChakraV3.Dialog.Content>
              <ChakraV3.DialogTitleSubtitle
                title='Reset MFA'
                subtitle='Are you sure you want to reset the MFA for this user?'
              />
              <ChakraV3.Dialog.Body>
                Are you sure you want to reset the MFA for this user?
              </ChakraV3.Dialog.Body>
              <ChakraV3.Dialog.Footer>
                <ChakraV3.HStack>
                  <ChakraV3.Button onClick={hide} size='sm' variant='subtle'>
                    Close
                  </ChakraV3.Button>
                  <HookedSubmitButton disabled={false} loadingText='Sending reset MFA email...'>
                    Reset MFA
                  </HookedSubmitButton>
                </ChakraV3.HStack>
              </ChakraV3.Dialog.Footer>
            </ChakraV3.Dialog.Content>
          </form>
        </FormProvider>
      </ChakraV3.Dialog.Positioner>
    </ChakraV3.Dialog.Root>
  );
});
